module.exports = __webpack_public_path__ + "static/media/Dead Island-01.be6b003a.svg";